import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CompletionSuggestions = ({ suggestions, onActionClick }) => {
  const priorityColors = {
    high: 'bg-error/10 border-error/20 text-error',
    medium: 'bg-warning/10 border-warning/20 text-warning',
    low: 'bg-success/10 border-success/20 text-success'
  };

  const priorityIcons = {
    high: 'AlertCircle',
    medium: 'AlertTriangle',
    low: 'Info'
  };

  if (suggestions?.length === 0) {
    return (
      <div className="bg-success/10 border border-success/20 rounded-lg p-6 text-center">
        <Icon name="CheckCircle" size={48} color="var(--color-success)" className="mx-auto mb-3" />
        <h3 className="text-lg font-semibold text-success mb-2">Profile Complete!</h3>
        <p className="text-sm text-muted-foreground">
          Your profile is 100% complete and ready for employers to view.
        </p>
      </div>
    );
  }

  return (
    <div className="bg-card rounded-lg border border-border p-4 md:p-6">
      <div className="flex items-center gap-3 mb-4">
        <Icon name="Lightbulb" size={24} color="var(--color-accent)" />
        <h3 className="text-lg md:text-xl font-heading font-semibold text-card-foreground">
          Complete Your Profile
        </h3>
      </div>
      <p className="text-sm text-muted-foreground mb-6">
        Add the following information to make your profile stand out to employers
      </p>
      <div className="space-y-3">
        {suggestions?.map((suggestion, index) => (
          <div
            key={index}
            className={`rounded-lg border p-4 ${priorityColors?.[suggestion?.priority]}`}
          >
            <div className="flex items-start gap-3">
              <Icon
                name={priorityIcons?.[suggestion?.priority]}
                size={20}
                color="currentColor"
                className="flex-shrink-0 mt-0.5"
              />
              <div className="flex-1">
                <h4 className="text-sm font-semibold mb-1">{suggestion?.title}</h4>
                <p className="text-xs opacity-90 mb-3">{suggestion?.description}</p>
                <Button
                  variant="outline"
                  size="sm"
                  onClick={() => onActionClick(suggestion?.action)}
                >
                  {suggestion?.actionLabel}
                </Button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CompletionSuggestions;